import { Fraction } from 'bi-fraction';
import { CRO_DECIMALS_ON_ETHEREUM } from '../config/constants';
export class WcroOnEthereum {
    constructor(contract) {
        this.contract = contract;
        this.getBalanceOf = async (address) => new Fraction(await this.contract.balanceOf(address)).shr(CRO_DECIMALS_ON_ETHEREUM);
    }
}
